import { dataMgr } from "../api/DataManagementApi";
import { InstrumentDataBody } from "quanterix-protos/run_data/v1/db_instrument_data";
import { RunPackageDto } from "quanterix-protos/run_data/v1/db_run_package";
import { RpckUploadResponse } from "quanterix-protos/shared/v1/rpck";
import { ExperimentData } from "quil";

export async function savingHelp(uploadResponse: RpckUploadResponse, id: string, experiment: RunPackageDto, inputDataFormat: string) {
    const rpckDetails = uploadResponse.details;
    const instrumentDataId = rpckDetails?.id;
    const instrumentDataCheck = await dataMgr.getInstrumentData({
        instrumentDataId,
    });
    // If the instrumentData record does not already exist, create it
    if (!instrumentDataCheck?.instrumentData) {
        const reqBody = InstrumentDataBody.fromPartial({
            rpckId: rpckDetails?.id,
            blobAccountName: 'any',
            blobContainerName: rpckDetails?.instrumentSerialNumber,
            blobFileName: rpckDetails?.name,
            instrumentSerialNumber: rpckDetails?.instrumentSerialNumber,
        });
        await dataMgr.writeInstrumentData({
            body: reqBody,
        });
    }

    const updatedExperiment = RunPackageDto.fromPartial({
        runPackageId: id,
        data: {
            ...experiment.data,
            instrumentDataId: rpckDetails?.id,
            inputDataFormat
        },
    });

    const updatedExperimentData: Partial<ExperimentData> = {
        experiment: updatedExperiment,
    };
    return updatedExperimentData;
}